























import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { RequestedContainerFields } from '@/types/graphql/schemaTypes';
import omit from 'lodash/omit';
import ContainerDetails from '@/components/inquiry/new/ContainerDetails.vue';
import { Table, TableColumn } from 'element-ui';

interface RequestedContainerInputWithId extends RequestedContainerFields {
  id: string;
}

@Component({
  components: {
    ContainerDetails,
    'el-table': Table,
    'el-table-column': TableColumn
  }
})
export default class ContainersList extends Vue {
  @Prop() public containers!: RequestedContainerFields[];
  @Prop({ default: false }) public readOnly!: boolean;
  public editedContainers: RequestedContainerInputWithId[] = [this.emptyContainer()];

  created() {
    if (this.containers && this.containers.length) {
      this.editedContainers = this.containers.map((obj) => {
        return {
          ...obj,
          id: `NOID-${Math.floor(Math.random() * 1000) + 1}`
        };
      });
    }
  }

  public emptyContainer(): RequestedContainerInputWithId {
    return {
      id: `NOID-${Math.floor(Math.random() * 1000) + 1}`,
      requestedContainerType: null,
      requestedContainerCount: null,
      contentNetWeight: null
    };
  }

  public addContainer() {
    this.editedContainers.push(this.emptyContainer());
  }

  public editContainer(container: any) {
    const containerIndex = this.editedContainers.findIndex((val) => {
      return val.id === container.id;
    });
    this.editedContainers.splice(containerIndex, 1, container);
  }

  public removeContainer(containerIndex: number) {
    const containers = this.editedContainers[containerIndex];
    return this.$delete(this.editedContainers, containerIndex);
  }

  public containerSizeFormatter(row: any, column: any, cellValue: string, index: number): string {
    return this.$t(`container.sizes.${cellValue}`) as string;
  }

  public unitFormatter(row: any, column: any, cellValue: string, index: number): string {
    return cellValue ? `${cellValue} kg` : '-';
  }

  @Watch('editedContainers', { deep: true, immediate: true })
  emitContainerDetails() {
    const noIdContainers = this.editedContainers.map((obj) => {
      return omit(obj, ['id']);
    });
    this.$emit('editContainers', noIdContainers);
  }
}
